import './infoBox.css';

export const InfoBox = ({ className, onClick, selected, children }) => {
    const selectedClass = selected ? 'selected' : '';

    if (onClick) {
        return (
            <div className={`info-box with-button ${className} ${selectedClass}`}>
                <button className="btn btn-link btn-block" onClick={onClick}>
                    {children}
                </button>
            </div>
        );
    }

    return <div className={`info-box ${className} ${selectedClass}`}>{children}</div>;
};

export default InfoBox;
